import AlphaHelpers from '../abstracts/classes/alpha-helpers'

document.addEventListener('DOMContentLoaded', () => {
  // apply Bootstrap button classes to Gutenberg buttons
  const buttons = AlphaHelpers.smartQuerySelectorAll('.wp-block-button:not(.no-btn-styles)')
  buttons.forEach((buttonWrapperEl) => {
    const btnStyle = buttonWrapperEl.classList.contains('secondary') ? 'secondary' : 'primary'
    const buttonLinkEl = buttonWrapperEl.querySelector('.wp-block-button__link')
    if (buttonLinkEl) {
      buttonLinkEl.classList.add('btn', `btn-${btnStyle}`)
    }
  })
})
